module.exports = __webpack_public_path__ + "static/media/lupa.41e75604.svg";